module.exports = __webpack_public_path__ + "img/download-app-2.26ba46ef.jpg";